<div class="host-rate-detail v4-layout-drawer-container flex flex-col">
  <div class="flex-1 v4-layout-info">
    <!-- 房东评价 -->
    <div class="v4-layout-field" *ngIf="rateDetail?.thirdparty_type !== 9">
      <span class="v4-layout-field-label" [class.inter]="isInternational">{{ 'rate.word.host_rate' | translate }}</span>
      <div class="v4-layout-field-control">
        <ng-container *ngIf="unsupportedRateChannel; else supportRateChannel1">
          <div class="unsupport-wrapper v4-layout-field-row">
            <button
              *ngIf="!rateDetail?.host_comment"
              nz-button
              nzSize="small"
              class="set-rate-btn"
              (click)="onClickSetRated('host')"
            >
              {{ 'review.order.status.reviewed.set_btn' | translate }}
              <!-- 设为已评价 -->
            </button>
            <div *ngIf="rateDetail?.host_comment" class="rate-text">
              {{ rateDetail?.host_comment_desc || ('rate.tab.both_rate' | translate) }}
            </div>
          </div>
        </ng-container>

        <ng-template #supportRateChannel1>
          <ng-container *ngIf="rateDetail?.host_comment; else hostEmpty">
            <div class="rate-score v4-layout-field-row">
              <nz-rate [ngModel]="rateDetail?.host_comment?.score" nzAllowHalf nzDisabled></nz-rate>
            </div>
            <div class="rate-text v4-layout-field-extra">{{ rateDetail?.host_comment?.content }}</div>
          </ng-container>
          <ng-template #hostEmpty>
            <div class="empty v4-layout-field-row">{{ 'rate.word.empty_rate' | translate }}</div>
          </ng-template>
        </ng-template>
      </div>
    </div>

    <!-- 房客评价 -->
    <div class="v4-layout-field">
      <span class="v4-layout-field-label" [class.inter]="isInternational">
        {{ 'rate.word.guest_rate' | translate }}
      </span>
      <div class="v4-layout-field-control">
        <ng-container *ngIf="unsupportedRateChannel; else supportedRateChannel">
          <div class="unsupport-wrapper v4-layout-field-row">
            <button
              *ngIf="!rateDetail?.guest_comment"
              nz-button
              nzSize="small"
              class="set-rate-btn"
              (click)="onClickSetRated('guest')"
            >
              {{ 'review.order.status.reviewed.set_btn' | translate }}
              <!-- 设为已评价 -->
            </button>
            <div *ngIf="rateDetail?.guest_comment" class="ra te-text">
              {{ rateDetail?.guest_comment_desc || ('rate.tab.both_rate' | translate) }}
            </div>

            <a *ngIf="threadId" routerLink="/app/inbox" [queryParams]="{ thread_id: threadId }">
              <button nz-button nzSize="small" class="no-min-width ml-2">
                {{ 'order.chat' | translate }}
              </button>
            </a>
            <button nz-button nzSize="small" class="no-min-width ml-2" (click)="onClickViewReservation()">
              {{ 'word.view_reservation' | translate }}
            </button>
          </div>
        </ng-container>

        <ng-template #supportedRateChannel>
          <ng-container *ngIf="rateDetail?.guest_comment; else guestEmpty">
            <div class="rate-score v4-layout-field-row">
              <nz-rate [ngModel]="rateDetail?.guest_comment?.score" nzAllowHalf nzDisabled></nz-rate>
            </div>
            <div class="v4-layout-field-extra">
              <div class="rate-text">{{ rateDetail?.guest_comment?.content }}</div>
              <div class="rate-image">
                <img
                  class="w-20 h-20 mt-2 mr-2 rounded-lg"
                  *ngFor="let photo of rateDetail?.guest_comment?.photos"
                  [src]="photo"
                />
              </div>
              <div class="rate-reply" *ngIf="rateDetail?.host_reply">
                <div class="rate-reply-content">
                  {{ 'rate.word.host_reply' | translate }}：{{ rateDetail?.host_reply?.content }}
                </div>
              </div>

              <div>
                <a *ngIf="threadId" routerLink="/app/inbox" [queryParams]="{ thread_id: threadId }">
                  <button nz-button nzSize="small" class="no-min-width">
                    {{ 'order.chat' | translate }}
                  </button>
                </a>
                <button nz-button nzSize="small" class="no-min-width ml-2" (click)="onClickViewReservation()">
                  {{ 'word.view_reservation' | translate }}
                </button>
              </div>
            </div>
          </ng-container>
          <ng-template #guestEmpty>
            <div class="empty v4-layout-field-row">{{ 'rate.word.empty_rate' | translate }}</div>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="pt-[30px] border-t border-solid border-c-gs">
    <button
      class="mr-3"
      nz-button
      nzType="primary"
      nzSize="large"
      (click)="displayRateModal()"
      *ngIf="
        (!rateDetail || [Status.Unrate_Both, Status.Unrate_Host].indexOf(rateDetail?.status) !== -1) &&
        !unsupportedRateChannel
      "
    >
      {{ 'rate.operate.btn_rate' | translate }}
    </button>
    <button
      class="mr-3"
      nzSize="large"
      nzType="primary"
      *ngIf="rateDetail?.status === Status.Rate_Both"
      nz-button
      (click)="displayRateReplyModal()"
    >
      {{ 'rate.word.reply' | translate }}
    </button>
    <button nz-button nzSize="large" (click)="close()">{{ 'word.close' | translate }}</button>
  </div>
</div>

<host-order-detail-sidebar></host-order-detail-sidebar>
